import React from 'react';

const SchemaGeneralSurgery = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What is General Surgery and what conditions does it treat?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "General surgery involves the surgical treatment of conditions related to the abdomen, digestive system, soft tissues, hernia, appendix, gallbladder, thyroid, and more."
                }
            },
            {
                "@type": "Question",
                "name": "When should I consult a general surgeon in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You should consult a general surgeon if you experience persistent abdominal pain, swelling, hernia symptoms, gallstones, piles, or if your doctor recommends surgery."
                }
            },
            {
                "@type": "Question",
                "name": "Is laparoscopic surgery better than open surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, laparoscopic (minimally invasive) surgery usually offers smaller cuts, less pain, faster recovery, and shorter hospital stays compared to traditional open surgery."
                }
            },
            {
                "@type": "Question",
                "name": "How long does it take to recover after general surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Recovery time depends on the type of procedure. Minimally invasive surgeries may take a few days to weeks, while major surgeries may require longer recovery."
                }
            },
            {
                "@type": "Question",
                "name": "Is general surgery safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, general surgery is safe when performed by experienced surgeons using advanced techniques and proper post-operative care."
                }
            },
            {
                "@type": "Question",
                "name": "What are the common surgeries performed in general surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Common procedures include hernia repair, appendix removal, gallbladder surgery, piles treatment, thyroid surgery, and breast surgery."
                }
            },
            {
                "@type": "Question",
                "name": "Do you provide emergency general surgery services in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, 24×7 emergency surgical services are available for conditions like appendicitis, trauma, and acute abdominal pain."
                }
            },
            {
                "@type": "Question",
                "name": "How do I prepare for a general surgery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Preparation may include medical tests, fasting before surgery, stopping certain medications, and following your doctor’s instructions carefully."
                }
            },
            {
                "@type": "Question",
                "name": "What is the cost of general surgery in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The cost varies depending on the type of surgery, complexity, and hospital facilities. A consultation with the surgeon will provide an accurate estimate."
                }
            },
            {
                "@type": "Question",
                "name": "How can I book an appointment for general surgery consultation?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can book an appointment by calling the hospital, visiting the website, or directly visiting the hospital for consultation."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
    );
};

export default SchemaGeneralSurgery;